import { IAppError } from '../IAppError';

export function formatErrorForLog(error: IAppError | Error | any): Record<string, any> {
  // Handle regular JavaScript errors that don't have IAppError structure
  if (error instanceof Error && !('code' in error)) {
    return {
      name: error.constructor.name,
      message: error.message,
      stack: error.stack,
      timestamp: new Date().toISOString(),
    };
  }

  // Handle IAppError instances
  return {
    name: error.constructor.name,
    code: error.code || 'UNKNOWN_ERROR',
    layer: error.layer || 'unknown',
    message: error.message,
    suggestions: error.suggestions ? {
      dx: error.suggestions.dx,
    } : undefined,
    cause: formatCause(error.cause),
    timestamp: new Date().toISOString(),
  };
}

function formatCause(cause: unknown): string | undefined {
  if (cause instanceof Error) return cause.stack || cause.message;
  if (typeof cause === 'string') return cause;
  try {
    return JSON.stringify(cause);
  } catch {
    return 'Unserializable cause';
  }
}